module.exports = __webpack_public_path__ + "static/media/DAPC-2022-26.728a1c12.pdf";